import React, {useState} from 'react';
import ArrAccordion, {
  AccordionSection,
} from '../common/arr-accordion/ArrAccordion';
import ArrTreeView from '../common/arr-tree-view/ArrTreeView';
import ArrSingleSelectDropdown, {
  ArrSingleSelectProps,
} from '../common/arr-select-dropdown/ArrSingleSelectDropdown';
import {Box, Button} from '@mui/material';

export type SelectSourceSectionType = 'tree' | 'dropdown';

export interface SelectSourceSection {
  id: string;
  label: string;
  type: SelectSourceSectionType;
  treeData?: any;
  dropdownData?: ArrSingleSelectProps;
}

export interface SelectSourceProps {
  sections: SelectSourceSection[];
  onSaveSelection: (sectionId: string, selection: any) => void;
}

const SelectSource: React.FC<SelectSourceProps> = ({
  sections,
  onSaveSelection,
}) => {
  const [selections, setSelections] = useState<Record<string, any>>({});

  const handleSelectionChange = (sectionId: string, value: any) => {
    setSelections((prev) => ({...prev, [sectionId]: value}));
  };

  const handleSave = (sectionId: string) => {
    onSaveSelection(sectionId, selections[sectionId]);
  };

  const renderContent = (section: SelectSourceSection) => {
    if (section.type === 'tree') {
      return (
        <>
          <div data-testid="arr-tree-view">
            <ArrTreeView
              itemsList={section.treeData.itemsList}
              isShowCheckbox={true}
              setSelectedItem={(val) => handleSelectionChange(section.id, val)}
              selectedItem={selections[section.id]}
              {...section.treeData.props}
            />
          </div>
          <Box mt={2} sx={{display: 'flex', justifyContent: 'flex-start'}}>
            <Button
              variant="contained"
              onClick={() => handleSave(section.id)}
              data-testid={`arr-save-button-${section.id}`}
            >
              Save Selections
            </Button>
          </Box>
        </>
      );
    } else if (section.type === 'dropdown') {
      const dropdownData = {
        ...section.dropdownData,
        dropdownLabel: section.dropdownData?.dropdownLabel ?? '',
        dropdownItems: section.dropdownData?.dropdownItems ?? [],
      };
      return (
        <>
          <div data-testid="arr-single-select-dropdown">
            <ArrSingleSelectDropdown
              {...dropdownData}
              selectedValues={selections[section.id] ?? null}
              onSelectionChange={(val) =>
                handleSelectionChange(section.id, val)
              }
              dataTestId="asd-select-source-selections"
            />
          </div>
          <Box mt={2} sx={{display: 'flex', justifyContent: 'flex-start'}}>
            <Button
              variant="contained"
              onClick={() => handleSave(section.id)}
              data-testid={`arr-save-button-${section.id}`}
            >
              Save Selections
            </Button>
          </Box>
        </>
      );
    }
    return <></>;
  };

  const accordionSections: AccordionSection[] = sections.map((section) => ({
    id: section.id,
    title: section.label,
    content: renderContent(section) ?? <></>,
  }));

  return (
    <div data-testid="arr-accordion">
      <ArrAccordion
        dataTestId="select-source"
        sections={accordionSections}
      />
    </div>
  );
};

export default SelectSource;
